import "@pjs/theming/dist/theme.css";
import { injectCss } from "../../../../../../../node_modules/@pebblepad/pebblepack/runtime/InjectCss.runtime.js";
injectCss(`.uui-select-reason-step__textarea{width:100%;min-height:var(--layout-input-multi-line-min-height-long)}`);